import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, FileText } from 'lucide-react';

const WHATSAPP = 'https://wa.me/32488152028?text=' + encodeURIComponent('Hallo Max Q, ik heb een vraag over een renovatie.');
const PHONE = '+32488152028';

const MobileStickyBar = () => {
  const location = useLocation();

  // Hide on admin and bedankt pages
  if (location.pathname.startsWith('/admin') || location.pathname.startsWith('/bedankt')) {
    return null;
  }

  return (
    <div
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 shadow-[0_-8px_24px_rgba(0,0,0,0.08)]"
      data-testid="mobile-sticky-cta"
      data-link-location="mobile_sticky"
    >
      <div className="grid grid-cols-3">
        <a
          href={'tel:' + PHONE}
          className="flex flex-col items-center justify-center py-3 text-[#3a190b] hover:bg-gray-50 transition-colors"
          data-testid="mobile-cta-call"
        >
          <Phone className="h-5 w-5" />
          <span className="text-[11px] mt-0.5 font-medium">Bel</span>
        </a>
        <a
          href={WHATSAPP}
          target="_blank"
          rel="noopener noreferrer"
          className="wa-attention flex flex-col items-center justify-center py-3 text-white bg-[#25D366] hover:brightness-95 transition-all"
          data-testid="mobile-cta-whatsapp"
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-[11px] mt-0.5 font-medium">WhatsApp</span>
        </a>
        <Link
          to="/start"
          className="flex flex-col items-center justify-center py-3 text-white bg-[#3a190b] hover:bg-[#500000] transition-colors"
          data-testid="mobile-cta-offer"
        >
          <FileText className="h-5 w-5" />
          <span className="text-[11px] mt-0.5 font-medium">Offerte</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileStickyBar;
